module.exports = __webpack_public_path__ + "img/nuki-smartlock-md.c2b7a3ea.svg";